import { Header, Label, List, Segment } from '@mairistem/composants';
import dayjs from 'dayjs';
import _ from 'lodash';

import type { CycleType } from '@/types';

type RelancesCyclesProps = {
  cycles: CycleType[];
};

const RelancesCycles = (props: RelancesCyclesProps) => {
  const { cycles } = props;

  return (
    <>
      <Header as="h3">
        <Header.Content>
          {_.size(cycles) === 1
            ? 'Cycle de facturation sélectionné'
            : 'Cycles de facturation sélectionnés'}
          <Header.Subheader style={{ marginTop: '0.5em' }}>
            Les factures impayées
            {_.size(cycles) === 1 ? ' du cycle suivant ' : ' des cycles suivants '}
            seront relancées.
          </Header.Subheader>
        </Header.Content>
      </Header>
      <List>
        {_.map(
          cycles,
          ({ identifiant, titre, dateEmission, logicielFacturier, nombreFacturesImpayes }) => (
            <Segment key={`cycle@${identifiant}`}>
              <List.Item>
                <List.Header as="h5" style={{ display: 'flex', alignItems: 'center' }}>
                  <Header.Content style={{ flex: 1 }}>
                    {titre}{' '}
                    <span
                      style={{ opacity: 0.5 }}
                    >{`(${dayjs(dateEmission).format('DD/MM/YYYY')})`}</span>
                  </Header.Content>
                  <Label basic circular>
                    {logicielFacturier.nom}
                  </Label>
                  <Header.Content style={{ marginLeft: '5em' }}>
                    {nombreFacturesImpayes === 1
                      ? '1 facture impayée'
                      : `${nombreFacturesImpayes} factures impayées`}
                  </Header.Content>
                </List.Header>
              </List.Item>
            </Segment>
          ),
        )}
      </List>
    </>
  );
};

export default RelancesCycles;
